import React, { useCallback } from 'react';
import {
    IconFlyoutMenuButton,
    IconButtonTheme,
    IconButtonSize,
    Panel,
    PanelTheme,
    FlyoutDirection,
    FlyoutMenuButton,
    ButtonTheme,
    FlyoutMenuTheme,
} from '@apply/components';
import { faBell, faUserCircle, faTrashCan, faEdit } from '@fortawesome/free-regular-svg-icons';
import { FlyoutMenuButtonBorderRadius } from '../FlyoutMenuButtons/FlyoutMenuButton';

export const FlyoutMenuButtonDemo: React.FC<{}> = ({}) => {
    const buttonClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Icon Flyout Menu Button :</h2>
            <br />
            <IconFlyoutMenuButton
                id='Flyout Left White Bell Button With Count'
                theme={IconButtonTheme.White}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faBell}
                bubbleNumber={25}
                direction={FlyoutDirection.Left}
            >
                <Panel
                    theme={PanelTheme.Blue}
                    width='150px'
                >
                    Panel Items shown left
                </Panel>
            </IconFlyoutMenuButton>
            <br />
            <IconFlyoutMenuButton
                id='Flyout Left White Bell Button With Count'
                theme={IconButtonTheme.White}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faBell}
                bubbleNumber={25}
                direction={FlyoutDirection.Right}
            >
                <Panel
                    theme={PanelTheme.Blue}
                    width='150px'
                >
                    Panel Items shown right
                </Panel>
            </IconFlyoutMenuButton>
            <br />
            <IconFlyoutMenuButton
                id='Fly Down White Profile Button With No Count'
                theme={IconButtonTheme.White}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faUserCircle}
                hint='View Profile'
                direction={FlyoutDirection.Down}
            >
                <ul style={{ textAlign: 'center' }}>
                    <li>
                        <a>Logout</a>
                    </li>
                </ul>
            </IconFlyoutMenuButton>
            <br />
            <IconFlyoutMenuButton
                id='White Profile Button Disabled'
                theme={IconButtonTheme.White}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faUserCircle}
                disabled={true}
                direction={FlyoutDirection.Down}
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </IconFlyoutMenuButton>
            <br />
            <IconFlyoutMenuButton
                id='Flyout Left Transparent Bell Button With Count'
                theme={IconButtonTheme.Transparent}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faBell}
                bubbleNumber={25}
                direction={FlyoutDirection.Left}
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </IconFlyoutMenuButton>
            <br />
            <IconFlyoutMenuButton
                id='Flyout Right Transparent Bell Button With Count'
                theme={IconButtonTheme.Transparent}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faBell}
                bubbleNumber={25}
                direction={FlyoutDirection.Right}
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </IconFlyoutMenuButton>
            <br />
            <IconFlyoutMenuButton
                id='Flyout Down Transparent Profile Button With No Count'
                theme={IconButtonTheme.Transparent}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faUserCircle}
                hint='View Profile'
                direction={FlyoutDirection.Down}
            >
                <ul style={{ textAlign: 'center' }}>
                    <li>
                        <a>Logout</a>
                    </li>
                </ul>
            </IconFlyoutMenuButton>
            <br />
            <IconFlyoutMenuButton
                id='Transparent Profile Button Disabled'
                theme={IconButtonTheme.Transparent}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faUserCircle}
                disabled={true}
                direction={FlyoutDirection.Down}
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </IconFlyoutMenuButton>
            <br />
            <Panel
                theme={PanelTheme.White}
                width='40px'
            >
                <IconFlyoutMenuButton
                    id='Red Trash Button With Count'
                    theme={IconButtonTheme.Red}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faTrashCan}
                    bubbleNumber={9}
                    direction={FlyoutDirection.Left}
                >
                    <ul>
                        <li>Item 1</li>
                    </ul>
                </IconFlyoutMenuButton>
                <br />
                <IconFlyoutMenuButton
                    id='Red Trash Button With Count'
                    theme={IconButtonTheme.Red}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faTrashCan}
                    bubbleNumber={9}
                    direction={FlyoutDirection.Right}
                >
                    <ul>
                        <li>Item 1</li>
                    </ul>
                </IconFlyoutMenuButton>
                <br />
                <IconFlyoutMenuButton
                    id='Red Trash Button With No Count'
                    theme={IconButtonTheme.Red}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faTrashCan}
                    hint='Delete Item'
                    direction={FlyoutDirection.Down}
                >
                    <ul style={{ textAlign: 'center' }}>
                        <li>
                            <a>View Details</a>
                        </li>
                    </ul>
                </IconFlyoutMenuButton>
                <br />
                <IconFlyoutMenuButton
                    id='Disabled Red Trash Button With No Count'
                    theme={IconButtonTheme.Red}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faTrashCan}
                    hint='Delete Item'
                    disabled={true}
                    direction={FlyoutDirection.Down}
                >
                    <ul>
                        <li>Item 1</li>
                    </ul>
                </IconFlyoutMenuButton>
                <br />
                <IconFlyoutMenuButton
                    id='Blue Edit Button With Count'
                    theme={IconButtonTheme.Blue}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faEdit}
                    bubbleNumber={3}
                    direction={FlyoutDirection.Left}
                >
                    <ul>
                        <li>Item 1</li>
                    </ul>
                </IconFlyoutMenuButton>
                <br />
                <IconFlyoutMenuButton
                    id='Blue Edit Button With Count'
                    theme={IconButtonTheme.Blue}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faEdit}
                    bubbleNumber={3}
                    direction={FlyoutDirection.Right}
                >
                    <ul>
                        <li>Item 1</li>
                    </ul>
                </IconFlyoutMenuButton>
                <br />
                <IconFlyoutMenuButton
                    id='Blue Edit Button With No Count'
                    theme={IconButtonTheme.Blue}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faEdit}
                    direction={FlyoutDirection.Down}
                >
                    <ul style={{ textAlign: 'center' }}>
                        <li>
                            <a>Logout</a>
                        </li>
                    </ul>
                </IconFlyoutMenuButton>
                <br />
                <IconFlyoutMenuButton
                    id='Disabled Blue Edit Button With No Count'
                    theme={IconButtonTheme.Blue}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faEdit}
                    disabled={true}
                    direction={FlyoutDirection.Down}
                >
                    <ul>
                        <li>Item 1</li>
                    </ul>
                </IconFlyoutMenuButton>
            </Panel>
            <br />
            <br />
            <h2>Flyout Menu Button :</h2>
            <FlyoutMenuButton
                id='Flyout Button (dark blue active)'
                theme={FlyoutMenuTheme.DarkBlueActive}
                borderRadius={FlyoutMenuButtonBorderRadius.Small}
                handleClick={buttonClick}
                disabled={false}
                direction={FlyoutDirection.Down}
                buttonContent='Flyout Button'
                width='150px'
                height='40px'
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </FlyoutMenuButton>
            <br />
            <FlyoutMenuButton
                id='Flyout Button (blue)'
                theme={FlyoutMenuTheme.Blue}
                borderRadius={FlyoutMenuButtonBorderRadius.Small}
                handleClick={buttonClick}
                disabled={false}
                direction={FlyoutDirection.Down}
                buttonContent='Flyout Button'
                width='150px'
                height='40px'
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </FlyoutMenuButton>
            <br />
            <FlyoutMenuButton
                id='Flyout Button (red)'
                theme={FlyoutMenuTheme.Red}
                borderRadius={FlyoutMenuButtonBorderRadius.Small}
                handleClick={buttonClick}
                disabled={false}
                direction={FlyoutDirection.Down}
                buttonContent='Flyout Button'
                width='150px'
                height='40px'
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </FlyoutMenuButton>
            <br />
            <FlyoutMenuButton
                id='Flyout Button (transparent)'
                theme={FlyoutMenuTheme.Transparent}
                borderRadius={FlyoutMenuButtonBorderRadius.Small}
                handleClick={buttonClick}
                disabled={false}
                direction={FlyoutDirection.Down}
                buttonContent='Flyout Button'
                width='150px'
                height='40px'
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </FlyoutMenuButton>
            <br />
            <FlyoutMenuButton
                id='Flyout Button (transparent red)'
                theme={FlyoutMenuTheme.TransparentRed}
                borderRadius={FlyoutMenuButtonBorderRadius.Small}
                handleClick={buttonClick}
                disabled={false}
                direction={FlyoutDirection.Down}
                buttonContent='Flyout Button'
                width='150px'
                height='40px'
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </FlyoutMenuButton>
            <br />
            <FlyoutMenuButton
                id='Flyout Button (white)'
                theme={FlyoutMenuTheme.White}
                borderRadius={FlyoutMenuButtonBorderRadius.Small}
                handleClick={buttonClick}
                disabled={false}
                direction={FlyoutDirection.Right}
                buttonContent='Flyout Button'
                width='150px'
                height='40px'
            >
                <ul>
                    <li>Item 1</li>
                </ul>
            </FlyoutMenuButton>
        </div>
    );
};
